import { css } from 'styled-components';
import colors from '../../style/colors';

export const sizes = {
  auto: {
    width: 'auto',
  },
  xs: {
    width: '160px',
  },
  sm: {
    width: '240px',
  },
  md: {
    width: '436px',
  },
  lg: {
    width: '600px',
  },
};

export const variants = {
  default: css`
    box-shadow:
      0 4px 8px -4px rgba(0, 0, 0, 0.24),
      0 0 8px rgba(0, 0, 0, 0.12);
    background: ${colors.white};
  `,
};
